import { render, staticRenderFns } from "./DetailProposalLpj.vue?vue&type=template&id=24219c5b"
import script from "./DetailProposalLpj.vue?vue&type=script&lang=js"
export * from "./DetailProposalLpj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports